import './app.css';


/* is production */
// const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

analyticsEvent('Page', 'load', {eventLabel: 'Successfully'});



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Corki'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['PT Sans:400,400i:cyrillic']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    if (navigator.share !== undefined) {
        document.querySelector('.share__item--all').classList.add('share__item--show');
    }

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {

            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: meta.title,
                    url: meta.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* service worker */
// if ('serviceWorker' in navigator && isProd) {
//     navigator.serviceWorker.register('./sw.js');
// }



/* curved text */
import CircleType from 'circletype';

const isMobile = document.documentElement.clientWidth <= 425 || document.documentElement.clientHeight <= 425;

const regularPersonsTitles = [...document.querySelectorAll('.person:not([data-connection]) .person__title')];
regularPersonsTitles.forEach(title => {
    if (isMobile) {
        new CircleType(title).dir(-1).radius(45);
    } else {
        new CircleType(title).dir(-1).radius(90);
    }
});

const personFiveTitle = document.querySelector('.person--5 .person__title');
if (isMobile) {
    new CircleType(personFiveTitle).radius(60);
} else {
    new CircleType(personFiveTitle).radius(110);
}

const personSixTitle = document.querySelector('.person--6 .person__title');
if (isMobile) {
    new CircleType(personSixTitle).radius(60);
} else {
    new CircleType(personSixTitle).radius(120);
}

const personSevenTitle = document.querySelector('.person--7 .person__title');
if (isMobile) {
    new CircleType(personSevenTitle).radius(60);
} else {
    new CircleType(personSevenTitle).radius(110);
}

const personEightTitle = document.querySelector('.person--8 .person__title');
if (document.documentElement.clientWidth <= 500) {
    if (document.documentElement.clientWidth <= 400) {
        if (document.documentElement.clientWidth <= 350) {
            if (document.documentElement.clientWidth <= 300) {
                new CircleType(personEightTitle).dir(-1).radius(60);
            } else {
                new CircleType(personEightTitle).dir(-1).radius(65);
            }
        } else {
            new CircleType(personEightTitle).dir(-1).radius(75);
        }
    } else {
        new CircleType(personEightTitle).dir(-1).radius(90);
    }
} else {
    new CircleType(personEightTitle).dir(-1).radius(105);
}

const personNineTitle = document.querySelector('.person--9 .person__title');
if (isMobile) {
    new CircleType(personNineTitle).dir(-1).radius(60);
} else {
    new CircleType(personNineTitle).dir(-1).radius(120);
}



/* popups */
const popupPersons = [...document.querySelectorAll('.person[data-popup]')];

popupPersons.forEach(person => {
    person.addEventListener('click', () => {
        document.querySelector('body').setAttribute('data-popup', person.dataset.popup);

        analyticsEvent('Popup', 'open', {eventLabel: person.querySelector('.person__title').textContent});
    });
});

const closeButtons = [...document.querySelectorAll('.popup__close')];

closeButtons.forEach(button => {
    button.addEventListener('click', () => {
        document.querySelector('body').removeAttribute('data-popup');
    });
});

document.querySelector('.persons').addEventListener('click', () => {
    const popupIsVisible = getComputedStyle(document.querySelector('.popup--' + document.querySelector('body').dataset.popup)).getPropertyValue('opacity') === '1'

    if (popupIsVisible) {
        document.querySelector('body').removeAttribute('data-popup');
    }
});

document.onkeydown = (e) => {
    e = e || window.event;

    if ('key' in e) {
        const isEscape = e.key === 'Escape' || e.key === 'Esc';
        if (isEscape) {
            document.querySelector('body').removeAttribute('data-popup');
        }
    }
};



/* vivus */
const Vivus = require('vivus');

const vivusOptions = {
    duration: 200,
    pathTimingFunction: Vivus.EASE_IN
};

new Vivus('line_1', vivusOptions);

new Vivus('line_2', vivusOptions);

new Vivus('line_3', vivusOptions);

new Vivus('line_4', vivusOptions);

new Vivus('line_5', vivusOptions);

new Vivus('line_7', vivusOptions);

new Vivus('line_8', vivusOptions);

new Vivus('line_9', vivusOptions);

new Vivus('line_10', vivusOptions);

new Vivus('line_11', vivusOptions);

new Vivus('line_12', vivusOptions);

new Vivus('line_13', vivusOptions);

new Vivus('line_14', vivusOptions);



/* in view */
const inView = require('in-view');

const showEmoji = (index) => {
    document.querySelector('.emoji--' + index).classList.add('emoji--show')
};

inView('#line_6')
    .on('enter', (elem) => {
        elem.classList.add('line--show');
    });

inView('#line_7')
    .on('enter', () => {
        showEmoji(1);
    });

inView('#line_8')
    .on('enter', () => {
        showEmoji(2);
    });

inView('#line_9')
    .on('enter', () => {
        showEmoji(3);
    });

inView('#line_12')
    .on('enter', () => {
        showEmoji(4);
    });



/* iframe height */
window.onload = () => {
    setInterval(() => {
        window.parent.postMessage(document.querySelector('.main').offsetHeight, '*');
        // window.parent.postMessage(document.querySelector('.main').offsetHeight, 'https://m.lenta.ru');
    }, 1000);
}




// WEBPACK FOOTER //
// ./app.js